import React from "react";
import { RouteErrorBoundary } from "./RouteErrorBoundary";
import { Alert, Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

export const AdminErrorBoundary: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const navigate = useNavigate();

  const AdminFallback = () => (
    <Box sx={{ p: 4 }}>
      <Alert severity="error" sx={{ mb: 2 }}>
        Error en el panel de administración
      </Alert>
      <Typography>
        Ocurrió un error en el panel de administración. Por favor, recarga la
        página.
      </Typography>
      <Box sx={{ mt: 2 }}>
        <Button variant="contained" onClick={() => navigate("/admin-v2")}>
          Volver al panel
        </Button>
      </Box>
    </Box>
  );

  return (
    <RouteErrorBoundary
      fallback={<AdminFallback />}
      onReset={() => navigate("/admin-v2")}
    >
      {children}
    </RouteErrorBoundary>
  );
};
